import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        main: {
            width: '100%',

            '.swiper-wrapper': {
                alignItems: 'stretch',
                mb: remCalc(34),
            },
            '.swiper-slide': {
                h: 'unset !important',
            },
        },
        container: {
            maxWidth: {lg: remCalc(1400), base: '100%'},
            mx: 'auto',
            mb: {base: 0, md: remCalc(16), lg: remCalc(40)},
            px: {base: remCalc(16), sm: remCalc(24), lg: 0},
            flexDirection: 'column',
            textAlign: 'center',
            justifyContent: 'center',
        },
        chevronIcon: {
            width: {base: remCalc(24), sm: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            height: {base: remCalc(24), sm: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            position: 'absolute',
            backgroundColor: 'background.default',
            borderWidth: remCalc(1),
            borderColor: 'border.dark',
            borderRadius: '50%',
            top: {base: remCalc(166), sm: remCalc(84), md: remCalc(113), lg: remCalc(166)},
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: '10',
        },
        heading: {
            pt: {base: remCalc(16), md: remCalc(40)},
            pb: {base: remCalc(16), md: remCalc(24)},
            w: '100%',
            textStyle: 'head-large',
            fontWeight: 'medium',
        },
        bodycopy: {
            w: '100%',
            textStyle: 'body-large',
            fontWeight: 'normal',
            pb: {base: remCalc(16), md: remCalc(40)},
        },
        tilecontainer: {
            w: '100%',
            gap: {base: remCalc(16), md: remCalc(24)},
            mb: remCalc(24),
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
        tile: {
            w: '100%',
            h: '100%',
            gap: remCalc(24),
            justifyContent: 'space-between',
            flexDirection: 'column',
        },
        tiletextbox: {
            gap: remCalc(24),
        },
        tileimage: {
            h: '100%',
        },
        tiletitle: {
            textStyle: 'head-small',
            fontWeight: 'medium',
        },
        tilebodycopy: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        features: {
            listStyleType: 'none',
        },
        feature: {
            py: remCalc(20),
        },
        cta: {
            w: '100%',
            textDecoration: 'none !important',
            alignSelf: 'center',
        },
    },
}
